export default __webpack_public_path__ + "static/media/pinterest-logo-transparent-white.f7a305fe.png";